/*
 * @Author: luting
 * @Date: 2022-05-07 13:53:43
 * @lastEditors: luting
 * @LastEditTime: 2022-12-06 14:35:07
 */
import React, { forwardRef, useImperativeHandle, useEffect, useState } from 'react';
import { FormComponentProps } from 'sup-ui/lib/form';
import { Form, Select, message, Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';
import { getHostseApi, getNodeTypeListApi, updatNode } from 'root/services/netWork';
import Modal from 'root/components/CommonModal';
import styles from './index.less';

interface IEditSysTime extends FormComponentProps {
  visible: boolean; // 控制modal显示隐藏
  onCancel: any; // 取消方法
}

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};

const DilatationNode = forwardRef<FormComponentProps, IEditSysTime>((props, ref) => {
  const { visible, onCancel, form } = props;
  const { getFieldDecorator } = form;
  const intl = useIntl();
  const [nodeTypeList, setNodeTypeList] = useState<any[]>([]);
  const [hsotList, setHsotList] = useState<any[]>([]);
  const [spinning, setSpinning] = useState(false);

  useImperativeHandle(ref, () => ({
    form,
  }));

  useEffect(() => {
    getHosts();
    getNodeTypeList();
  }, []);

  // 获取主机节点列表
  const getHosts = () => {
    getHostseApi().then((res) => {
      const { data = [] } = res;
      setHsotList(data);
    });
  };

  // 获取节点类型
  const getNodeTypeList = () => {
    getNodeTypeListApi().then((res: any) => {
      const { data = [] } = res;
      setNodeTypeList(data);
    });
  };

  // 扩容节点
  const handDilatationNodeSubmit = () => {
    form.validateFields((err: any, values: any) => {
      if (err) return;
      const { host, nodeType } = values;

      const params = {
        host,
        nodeType,
      };
      setSpinning(true);
      updatNode(params)
        .then(() => {
          message.success(intl.formatMessage(messages.success));
        })
        .finally(() => {
          setSpinning(false);
        });
    });
  };

  return (
    <Modal
      className={styles.title}
      bodyStyle={{ maxHeight: 500, overflowY: 'auto', paddingBottom: 0 }}
      title={intl.formatMessage(messages.title)}
      visible={visible}
      onOk={handDilatationNodeSubmit}
      height="auto"
      onCancel={onCancel}
      okButtonProps={{
        disabled: spinning,
      }}
      destroyOnClose
    >
      <Spin spinning={spinning}>
        <Form {...formItemLayout}>
          <Form.Item className={styles.addStar} label={intl.formatMessage(messages.host)} colon={false}>
            <Form.Item>
              {getFieldDecorator(`host`, {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.placeholderInput),
                  },
                ],
              })(
                <Select showSearch={true}>
                  {hsotList.map((item) => (
                    <Option key={item.id} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Form.Item>
          <Form.Item label={intl.formatMessage(messages.nodeType)}>
            {getFieldDecorator('nodeType', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.placeholderInput),
                },
              ],
            })(
              <Select>
                {nodeTypeList.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});

export default Form.create()(DilatationNode);
